import jobs from './jobs';
import passengers from './passengers';
import layout from './layout';

const index = {
  jobs,
  passengers,
  layout,
};

export default index;
